<template>
  <div class="q-open-container main-color" v-show="visible == true">
    <label class="label-2cols q-label" v-html="question.q"></label>
    <md-field class="input-2cols">
      <md-input
        :placeholder="question.placeholder?question.placeholder: 'Tu respuesta...'"
        type="text"
        :disabled="readOnly"
        v-model="answer"
        @change="emitValueOpen"

      ></md-input>
    </md-field>
  </div>
</template>

<script>
export default {
  name: "open-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: String,
      default: ""
    },
    readOnly:{
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitValueOpen: function() {
      console.log(this.answer);
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    }
  },
  data: function() {
    return {
      answer: this.answerProp,
      disabled: this.readOnly,
      visible: true
    };
  },
  watch: {
  // whenever question changes, this function will run
    answer: function(newAnswer, oldAnswer) {
      this.emitValueOpen();
    }
  },
  mounted: function() {
    if(this.question.q_key != null && this.question.q_key != ''){
      //console.log(this.question.q_key);

      let params = this.$route.query;
      let ans = params[this.question.q_key];

      if(ans != null && ans != ''){
        this.answer = ans;
        this.visible = false;
      }
    }
  }
};
</script>
